import React from 'react';

import './LoadingSpinner.scss';

const LoadingSpinner = () => {
    return (
        <div className="loader-container">
            <div className="spinner" />
        </div>
    );
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/common/LoadingSpinner.tsx